import { Injectable } from '@angular/core';
import {AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument} from 'angularfire2/firestore';
import {Observable} from 'rxjs';

interface Post {
    adr: string;
    num: string;
    txt: string;
   }

   @Injectable({
    providedIn: 'root'
  })
  export class DeckService {

    postsCol: AngularFirestoreCollection<Post>;
    posts: Observable<Post[]>;
  
    imagerK:string[] = new Array(8)
    numb:string[] = new Array(8)
    messages:string[] = new Array(8)


    filUp(res:any[]) {
        for (let n = 0; n < res.length; n++) {
            this.imagerK[n] = res[n].adr
            this.numb[n] = res[n].num
            this.messages[n] = res[n].txt
        }
    }
  

    constructor(private afs: AngularFirestore) {
            this.postsCol = this.afs.collection('imagesadr');
            this.posts = this.postsCol.valueChanges();
            this.postsCol.valueChanges().subscribe(res => {
                this.posts[0] = res
                this.filUp(res)
            });
    }
   
    
    getDeck() : any[] {
        return [
            { name: this.numb[0], image: this.imagerK[0], flipped: false, message:this.messages[0] },
            { name: this.numb[1], image: this.imagerK[1], flipped: false, message:this.messages[1] },
            { name: this.numb[2], image: this.imagerK[2], flipped: false, message:this.messages[2] },
            { name: this.numb[3], image: this.imagerK[3], flipped: false, message:this.messages[3] },
            { name: this.numb[4], image: this.imagerK[4], flipped: false, message:this.messages[4] },
            { name: this.numb[5], image: this.imagerK[5], flipped: false, message:this.messages[5] },
            { name: this.numb[6], image: this.imagerK[6], flipped: false, message:this.messages[6] },
            { name: this.numb[7], image: this.imagerK[7], flipped: false, message:this.messages[7] }
        ]        
    }



}
